import * as type from "../../types/API/logTDS";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getLogTDSReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_LOG_TDS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_LOG_TDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_LOG_TDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getLogTDSByIdReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.GET_LOG_TDS_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_LOG_TDS_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.GET_LOG_TDS_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addLogTDSReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.ADD_LOG_TDS:
      return {
        ...state,
        loading: true,
      };
    case type.ADD_LOG_TDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.ADD_LOG_TDS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const updateLogTDSReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.UPDATE_LOG_TDS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_LOG_TDS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.UPDATE_LOG_TDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteLogTDSReducer = (
  state = initialState,
  action: IAction
) => {
  switch (action.type) {
    case type.DELETE_LOG_TDS:
      return {
        ...state,
        loading: true,
      };
    case type.DELETE_LOG_TDS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_LOG_TDS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
